import { render, staticRenderFns } from "./LayoutSideButton.vue?vue&type=template&id=e71789e8&scoped=true&"
import script from "./LayoutSideButton.vue?vue&type=script&lang=ts&"
export * from "./LayoutSideButton.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutSideButton.vue?vue&type=style&index=0&id=e71789e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71789e8",
  null
  
)

export default component.exports